import React from 'react'

const MajorBook = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.24 6.35h-1.73V4.78a.75.75 0 00-.72-.78 13.29 13.29 0 00-6 .9c-.26.113-.511.247-.75.4a5.315 5.315 0 00-.75-.4 13 13 0 00-6-.9.75.75 0 00-.72.75v1.59H2.85A.74.74 0 002 7.1v12a.77.77 0 00.31.61.79.79 0 00.44.14c.083.01.167.01.25 0a15.35 15.35 0 018.23-1l.57.13c.118.03.242.03.36 0l.57-.13c2.39-.48 4.95-.17 8.23 1a.75.75 0 00.68-.1.77.77 0 00.31-.61V7.1a.74.74 0 00-.71-.75zM18 5.51v10.33a7.56 7.56 0 00-5.26.68V6.64A9.41 9.41 0 0118 5.51zm-6.73 1.13A9.38 9.38 0 006 5.51v10.33a7.875 7.875 0 011.71-.19 7.35 7.35 0 013.56.88V6.64zM3.52 18.05V7.83h.95v9a.76.76 0 00.75.75c-.55.14-1.12.29-1.7.47zm2.05-.54A6.2 6.2 0 018 17.16c-.817.058-1.63.175-2.43.35zM16 17.16a6.11 6.11 0 012.42.35 16.598 16.598 0 00-2.42-.35zm2.79.43c.55.13 1.12.28 1.71.46l.04-10.21h-1v9a.75.75 0 01-.32.61.74.74 0 01-.43.14z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorBook
